import axios from 'axios';
// eslint-disable-next-line no-unused-vars
import { filterParams } from 'utils';
import { getToken } from 'utils/storage';

const service = axios.create({
  timeout: 15000,
});

service.interceptors.request.use(
  (config) => {
    config.headers.token = getToken();
    // filterParams(config.data || config.params || {});
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response && response.data;
    if (res.code === -10) {
      alert('登录过期，请重新登录');
      localStorage.clear();
      window.location.href = '/login';
    }
    return res;
  },
  (error) => {
    // eslint-disable-next-line no-console
    console.error(error);
    throw new Error(error.message);
  },
);

export default service;
